import React, { useEffect } from 'react';

function Termeni() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const primaryOrange = "#ff8e18";
    const trustNavy = "#1c2e4a";

    return (
        <div className="bg-light min-vh-100 pb-5">
            <div className="text-center text-white" style={{ background: `linear-gradient(135deg, ${trustNavy} 0%, #000 100%)`, paddingTop: '120px', paddingBottom: '3rem' }}>
                <div className="container">
                    <h1 className="fw-bold display-5">Termeni si Conditii</h1>
                    <div style={{ width: '60px', height: '4px', background: primaryOrange, margin: '20px auto', borderRadius: '2px' }}></div>
                    <p className="opacity-75">Ultima actualizare: 2024</p>
                </div>
            </div>

            <div className="container mt-n5">
                <div className="card shadow-lg border-0 rounded-3 p-4 p-md-5" style={{ marginTop: '-40px' }}>
                    <div className="card-body text-secondary" style={{ fontSize: '1rem', lineHeight: '1.75' }}>

                        <p className="lead">
                            Va rugam sa cititi cu atentie termenii si conditiile de utilizare inainte de a folosi site-ul nostru.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">1. Informatii Generale</h4>
                        <p>
                            Site-ul SPCheapCars este operat de SC SPCheapCars SRL, cu sediul in Timisoara,
                            Str. Grigore Alexandrescu 121. Prin accesarea site-ului, acceptati acesti termeni.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">2. Preturile</h4>
                        <p>
                            Preturile afisate pe site sunt in <strong>EUR</strong> si includ TVA.
                            Cursul valutar RON afisat este informativ si se actualizeaza automat.
                            Pretul final se stabileste la momentul tranzactiei.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">3. Informatii despre Vehicule</h4>
                        <p>
                            Depunem toate eforturile pentru a asigura acuratetea informatiilor prezentate.
                            Fotografiile si specificatiile sunt orientative. Va recomandam sa verificati
                            personal vehiculul inainte de achizitie.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">4. Garantie</h4>
                        <p>
                            Toate vehiculele comercializate beneficiaza de garantie conform legislatiei in vigoare.
                            Detalii suplimentare pe pagina <a href="/garantie" style={{ color: primaryOrange }}>Garantie</a>.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">5. Livrare</h4>
                        <p>
                            Oferim servicii de livrare la nivel national. Costurile si termenele de livrare
                            sunt detaliate pe pagina <a href="/livrare" style={{ color: primaryOrange }}>Livrare</a>.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">6. Proprietate Intelectuala</h4>
                        <p>
                            Continutul site-ului (texte, imagini, logo-uri) este proprietatea SPCheapCars
                            si nu poate fi reprodus fara acord scris.
                        </p>

                        <h4 style={{ color: trustNavy }} className="fw-bold mt-4">7. Contact</h4>
                        <p>
                            Pentru orice intrebari legate de acesti termeni, ne puteti contacta la
                            telefon <strong>0741 811 511</strong> sau email <strong>contact@spcheapcars.ro</strong>.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Termeni;
